import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../app/store'
import { IDataSet, IDataSetFieldList, IDataSetFrequency, IDataSetList, IHistoricAnnualData, IDataSetFieldGroupList, ILegalBasesCover } from '../../models/app.interface'

const initialStateHistoricData: IHistoricAnnualData = {
    period: "",
    fileAvailabilityId: "",
    periodValue: "",
    displayText: "",
    selected: false,
    periodAreadyMappedToFileAvailabilityInCRM: false,
    alreadyHeld: false,
    version:""
}

const initialStateFrequency: IDataSetFrequency = {
    value: ""
}
const initialStateFieldGroupList: IDataSetFieldList = {
    id: "",
    groupFieldId: "",
    groupName: "",
    fieldName: "",
    fieldType: "",
    fieldLogicalName: "",
    sensitiveFlag: false,
    identifiableFlag: false,
    isGroupField: false,
    isPrimaryField: false,
    description: "",
    startDate: "",
    endDate: "",
    groupType: ""
}
const initialStateGroupFieldList: IDataSetFieldGroupList = {
    groupName: "",
    groupId: "",
    groupFieldList: [initialStateFieldGroupList]
}
const initialLegalBases: ILegalBasesCover = {
    value: "",
    crmId: "",
    text: "",
    checked: false,
    name: "",
    availableOnline: false,
    currentlyCheckedInCRM: false,
    displayDissemination: false,
    displayProcessing: false,
    dissemination: false,
    notes: "",
    orderBy: 0,
    otherComments: "",
    otherLegalBasis: false,
    processing: false,
    productLegalBasis: false,
    description: ""
}
const initialStateDataSet: IDataSet = {
    dataDissemination: false,
    serviceType: "",
    description: "",
    crmUID: "",
    aggregatedOrRecordLevelData: "",
    linkedToCohort: false,
    datasetFrequency: "",
    historicAnnualDataList: [initialStateHistoricData],
    serviceTypeOneOff: false,
    serviceTypeRegularBespoke: false,
    serviceTypeRegularStandard: false,
    serviceTypeSystemAccess: false,
    standardisationServiceLevelOptionsSelected: "",
    frequencylist: [initialStateFrequency],
    datasetCohort: "",
    selectedProductFieldsList: [initialStateFieldGroupList],
    firstPointer: 0,
    selectedPaginationPage: 0,
    updatedDaily: false,
    annualPeriodsExist: false,
    currentYTDExists: false,
    latestRelease: false,
    futureRelease: false,
    historicAnnual: false,
    initialHistoricAnnualDataList: [initialStateHistoricData],
    groupByFieldsList: [initialStateGroupFieldList],
    currentCRMSelectedDatasetFields: [initialStateFieldGroupList],
    existingHistoricAnnualDataList: [initialStateHistoricData],
    stepsMinimiseDataRequested: "",
    identifiableData: "",
    legalBasesIdentifiableData: "",
    dataSetLegalBasesList: [initialLegalBases],
    currentDataSetLegalBasesList: [initialLegalBases],
    dataSetSelectedLegalBasesOtherText: ""
}
const initialState: IDataSetList ={
    activeDataSet: 0,
    associatedProduct: [initialStateDataSet]
}


export const DataSetListSlice = createSlice({
    name: 'DataSetList',
    initialState,
    reducers: {
        setDataSetListDetailsData: (state: IDataSetList, action: PayloadAction<IDataSetList>) => {
            state = Object.assign(state, action.payload);
        },
        resetDataSetListDetailsData: (state: IDataSetList, action: PayloadAction<IDataSetList>) => {
            state = { ...initialState, ...action.payload };
        },
    }
});

export const { setDataSetListDetailsData, resetDataSetListDetailsData } = DataSetListSlice.actions;
export const getDataSetListDetails = (state: RootState) => state.dataSetListDetails;
export default DataSetListSlice.reducer;